export default {
  '404':
    '申し訳ございません。 あなたがアクセスしようとしているページは存在しないか、 または権限が不足。',
  login: {
    user: '用户名',
    account: 'アカウント',
    password: 'パスワード',
    signin: 'ログイン',
    signtitle: 'ユーザーログイン',
    forgetpassword: 'パスワードをお忘れですか',
    regsiter: '開発者登録',
    accountLogin: 'アカウントログイン',
    codeTips:
      '確認コード SMS が送信されました。有効時間は 30 分です。時間内に確認してください。',
    wechartLogin: 'WeChatログイン',
    phoneLogin: '電話ログイン',
    wetChatTips:
      'WeChatを使用してQRコードをスキャンしてログインしてください。'
  },
  common: {
    retrieveAfterSeconds: ' 2番目',
    getVerificationCode: '確認コードを取得する',
    uploadCompanyLogo:
      'アバター画像のアップロードは、JPG、PNG 形式をサポートしています!',
    uploadCompanyLogoSize:
      'アップロードするアバター画像のサイズは 2MB を超えることはできません!',
    uploadAvaterTips:
      'アバターは JPG、PNG 形式をサポートし、サイズは 2M を超えません',
    uploadSuccess: 'アップロードに成功した',
    uploadFail: 'アップロードに失敗した',
    i18nKey: 'i18nKey',
    i18nKeyRequire: 'i18nKeyを入力してください',
    sys:
      'Xiamen Entropy Technology Rapid Development Platformのフロントエンドフレームワーク',
    add: '新着',
    search: '検索',
    edit: '編集する',
    release: 'リリース',
    update: '改訂',
    delete: '消去',
    cancel: 'キャンセル',
    confirm: 'ok',
    selectDate: '日付を選択',
    select: '選んでください',
    success: '成功',
    fail: '失敗',
    remark: '述べる',
    status: '状態',
    name: '名前',
    statusRequire: 'ステータスを選択してください',
    remarkRequire: 'メモを入力してください',
    nameRequire: '名前を入力してください',
    confirmDelete: '削除を確認しますか?',
    successDelete: '正常に削除されました',
    cancelDelete: '削除されていない',
    addUser: 'ユーザーを追加する',
    addSuccess: '追加成功',
    inputUserName: 'ユーザー名を入力してください',
    sourceList: 'ソースリスト',
    targetList: '目的のリスト',
    addUserSuccess: 'ユーザーが正常に追加されました',
    selectUser: '続行する前にユーザーを選択してください',
    confirmDeleteUserTip: '選択したユーザーを削除してもよろしいですか?',
    startTime: '開始時間',
    startTimePla: '開始時間を入力してください',
    endTime: '終了時間',
    endTimePla: '終了時間を入力してください',
    userNamePla: 'アカウントを入力してください',
    logNamePla: 'ログ名を入力してください',
    logType: 'ログ種別',
    select1record: 'フォームをクリックしてレコードを選択してください。',
    confirmDeleteRecordTip: '選択したレコードを削除してもよろしいですか?',
    operation: '操作',
    errorNotice: 'エラーメッセージ',
    warningNotice: '確認',
    timeSnyc: '同期中',
    allSelect: 'すべてチェック',
    deleteFail: '削除に失敗',
    versionInfo: 'ログを変更する',
    signin: 'ログイン',
    languages: '言語',
    zh_cn: '中国語',
    en: '英語',
    logout: 'ログアウト',
    console: 'コンソール',
    platform: 'スマートDBS',
    userLogin: 'ユーザーログイン',
    action: '操作',
    requestError: 'リクエストエラー',
    requestServiceError: 'リクエストサービスエラー',
    importedDate: 'インポートされた、時間',
    extModifiedDate: 'サードパーティ修正時刻',
    lastUpdateTimeStamp: '最終更新時刻',
    createdDate: '作成時刻',
    createdBy: '作成者',
    modifiedDate: '変更時刻',
    modifiedBy: '変更者',
    enterValue: '内容を入力してください',
    searchValue: '検索',
    type: 'タイプ',
    Label: '備考',
    Enabled: '有効',
    selectRecod: 'データを選択してください',
    notice: 'お知らせ',
    save: '保存',
    cancelOperation: '操作をキャンセルする',
    refresh: 'リフレッシュ',
    saveSucess: '保存に成功した',
    lastupdateTime: '最終更新時刻',
    statisticalInfo: '統計情報',
    yes: '確認',
    not: 'キャンセル',
    active: 'アクティブ',
    unActive: '非アクティブ',
    tip: 'チップ',
    details: '詳細',
    download: 'すべてのデバイスをエクスポートする',
    loginLoading: 'ロード中、しばらくお待ちください',
    apiDoc: 'ドキュメント',
    sessionTimeOut:
      'セッションタイムアウトで、ログイン画面に遷移する。',
    send: '送信',
    sunday: '日',
    monday: '月',
    tuesday: '火',
    wednesday: '水',
    thursday: '木',
    friday: '金',
    saturday: '土',
    updateSuccess: '更新成功',
    loading: 'ローディング',
    noData: 'データなし',
    reset: 'リセット',
    inputKeyWord: 'キーワードを入力してください',
    copyRightInfo:
      'Copyright © 2021 ZKTECO CO., LTD. 無断転載を禁じます。',
    noPhoto: '写真は存在しません',
    isNoEmpty: '値を入力してください',
    emailValid: '正しいメールフォーマットを入力してください',
    httpValid: '正しいURL形式を入力してください',
    phoneValid: '正しい電話番号を入力してください',
    maxPhoneLen: '11は最大入力値',
    stringInRange:
      '文字列の長さは{start}と{end}の間でなければなりません',
    validatorInputLength: '{len} 文字未満で入力してください',
    alreadyBindEmail: 'メールがバインドされた',
    alreadyBindPhone: '電話番号はバインドさた',
    chooseOptions: '選択してください',
    emailCodes: '受信したメールの認証コードを入力してください',
    employeeNoTips: 'ジョブ番号は、数字と文字の組み合わせをサポートしています',
    inputIntegerTip: '正の整数を入力してください'
  },
  user: {
    accountByLogin: 'ログインアカウント',
    dbsPrivacy: '《Smart DBSプライバシーポリシー》',
    agree: '同意します',
    useEmailReg: 'メールで登録',
    usePhoneReg: '電話でサインアップ',
    pwdStrength: 'パスワードの強度',
    week: '弱い',
    middle: '真ん中',
    hight: '高い',
    noConfirmedPwd: '確認パスワードを空白にすることはできません',
    emailCodeError:
      '入力された確認コードが正しくありません。もう一度お試しください',
    sureEmailTip: '正しいメールアドレスを入力してください',
    onceLogin: 'すぐにログイン',
    baseInfo: '基本情報',
    activation: 'クリックして入手',
    userNameTips:
      'zkteco デバイス プラットフォームに登録されていないユーザー名を入力してください',
    emailTips:
      'zkteco デバイス プラットフォームに登録されていないメール アドレスを入力してください',
    emailCode: '検証コード',
    inputEmailCode: '確認コードを入力してください',
    emailCodeTips:
      '[確認コードを取得] をクリックすると、確認メールが届きます。 メールに記載されている 6 桁の認証コードを入力します。',
    inputPwdTips:
      'パスワードは数字と文字を含み、8 ～ 16 文字の長さである必要があります',
    services: '《サードパーティ開発者サービス契約》',
    regsiter: '登録',
    hasAcount: 'すでに開発者アカウントを持っている？',
    startTime: '登録開始時間',
    endTime: '登録終了時間',
    superAdmin: 'スーパー管理者',
    account: 'アカウント',
    status: '有効/無効',
    userName: 'ユーザー名',
    password: 'パスワード',
    confirmedPwd: 'パスワード',
    email: 'メールアドレス',
    phone: '携帯電話',
    sex: '性别',
    nickName: 'ニックネーム',
    department: 'セクション',
    role: 'ロール＃ロール＃',
    roleManagement: 'ロール管理',
    registerTime: '登録日',
    inputAccount: 'アカウント/携帯番号/メールアドレスを入力してください',
    inputForgetName: 'アカウントを入力してください',
    inputName: '名前を入力してください',
    inputPwd: 'パスワードを設定してください',
    inputPwd2: 'パスワードを入力してください',
    input2ndPwd: 'パスワードを再入力してください',
    pwdInconsistent: '2回のパスワード入力が異なる',
    inputEmail: 'メールアドレスを入力してください',
    inputPhone: '携帯電話に入力してください',
    inputNickName: 'ニックネームを入力してください',
    selectStatus: '状態を選択してください',
    addUser: '新規ユーザー',
    modifyUser: 'ユーザーの変更',
    userDetail: 'ユーザーの詳細',
    select1record: '表をクリックしてレコードを選択してください！',
    notAllowToChange: 'スーパー管理者は変更を許可しません！',
    notAllowToRemove: 'スーパー管理者は削除を許可しません！',
    notAllowToResetPwd: 'スーパー管理者はパスワードのリセットを許可しません！',
    notAllowToFreeze: 'スーパー管理者は凍結を許さない！',
    confirmDelete: '削除を確認しますか？',
    deleteUser: 'ユーザーの削除',
    confirmDeleteTip: '本当にアカウント名:｜のユーザーを削除しますか？',
    confirmResetPwd: 'パスワードをリセット',
    confirmResetPwdTip:
      '本当にアカウント名:｜のユーザーパスワードを12345678にリセットしますか？',
    successResetPwd: 'パスワードのリセットに成功しました',
    cancelResetPwd: 'パスワードのリセット解除',
    confirmFreeze: 'ユーザーのフリーズ',
    confirmFreezeTip: '本当にアカウント名:｜のユーザーをフリーズしますか？',
    successFreeze: 'ユーザーのフリーズに成功しました',
    cancelFreeze: 'ユーザーのフリーズ解除',
    notNeedUnfreeze:
      '現在のユーザーは有効で、フリーズを解除する必要はありません',
    confirmUnfreeze: '凍結解除',
    confirmUnfreezeTip:
      '本当にアカウント：｜のユーザーをフリーズ解除しますか？',
    successUnfreeze: 'ユーザーのフリーズ解除に成功しました',
    cancelUnfreeze: 'ユーザーのフリーズ解除',
    roleAllot: 'ロール割り当て',
    findPwdByPhone: '携帯電話から取得する',
    findPwdByEmail: '電子メールによる取得',
    resetPwdSuc: 'パスワードのリセットに成功した。',
    goBackStep: '前のページへ ',
    welcomeReg: '登録へようこそ',
    registerSuccess:
      '登録が完了した。 すぐにログインページに移動する',
    sendCodeSuccess: '認証コードの送信に成功しました',
    recoverPassword: 'パスワードの再取得',
    userNameNotEmpty: 'ユーザー名を入力してください。',
    passwordNotEmpty: 'パスワードを入力してください。',
    next: '次へ',
    code: '認証コード',
    requireCode: '認証コードを入力してください。',
    codeNotEmpty: '認証コードを空にすることはできません。',
    codeError: '認証コードエラー',
    goSign: 'ログインページに移動する',
    add: '新しい従業員',
    delete: '削除された従業員',
    expirationDate: '有効期限'
  },
  department: {
    addDept: '部門を追加',
    updateDept: '編集部門',
    parentDept: '親部門',
    deptName: '部署名',
    deptStatus: '部門のステータス',
    nameRequire: '部署名を入力してください',
    notDeleteRoot: 'ルート セクタは削除できません！',
    notDeleteDept: 'この部門にはサブ部門が含まれており、削除できません！',
    confirmDeleteDeptTip: '本当にこの部門を削除しますか？',
    selectDept: '続行する前に部門を選択してください'
  },
  area: {
    addArea: 'エリアを追加',
    updateArea: '編集エリア',
    parentArea: '親エリア',
    areaName: 'エリア名',
    areaStatus: '地域の状況',
    nameRequire: '地域名を入力してください',
    notDeleteRoot: 'ルート ゾーンは削除を許可しません！',
    notDeleteArea: 'このエリアにはサブエリアが含まれており、削除できません！',
    confirmDeleteAreaTip: '本当にこのエリアを削除しますか?？',
    selectArea: '続行する前にエリアを選択してください'
  },
  resource: {
    resourceName: 'リソース名',
    sortNo: '選別',
    resourceEvent: 'ボタンイベント',
    resourceType: 'タイプ',
    notDeleteRoot: 'ルート リソースの削除は許可されていません',
    notUpdateRoot: 'ルート リソースの変更は許可されていません',
    addResource: 'リソースを追加する',
    updateResource: 'リソースを更新する',
    confirmDeleteTip: '本当にリソースを削除しますか：',
    icon: 'アイコン',
    routerName: '路線名',
    btnGroup: 'グループ名',
    urlRequire: 'URLを入力してください',
    routerNameRule: '開発構成ルート名と同じ',
    btnGroupRequire: 'ボタン グループ名を入力してください',
    btnTypeRequire: 'ボタンの種類を選択してください',
    btnStyleRequire: 'ボタンのスタイルを選択してください',
    btnType: 'ボタンタイプ',
    btnStyle: 'ボタンのスタイル',
    btnEffect: 'ボタン効果',
    parentResource: '親リソース',
    default: 'デフォルトのボタン',
    primary: 'メインボタン',
    success: '成功ボタン',
    text: '文章',
    info: '情報ボタン',
    warning: '警告ボタン',
    danger: '危険ボタン',
    plain: '無地のボタン',
    round: '丸みのあるボタン',
    circle: '丸いボタン',
    typeRequire: 'リソースタイプを選択してください',
    sortNoRequire: 'シリアル番号を入力してください',
    intRequire: '正の整数を入力してください',
    parentRequire: '親リソースを選択してください',
    parentRule1: '親リソースをリソース自体にすることはできません',
    parentRule2: '親リソースをこのリソースの子リソースにすることはできません',
    resourceEventRequire: 'ボタンイベントを入力してください',
    disabled: '無効化'
  },
  role: {
    addRole: '役割を追加',
    addRoleGroup: '役割グループを追加',
    role: '役割',
    addRoleSuccess: 'ロールが正常に追加されました',
    updateRoleSuccess: '役割が正常に変更されました',
    roleGroup: '役割グループ',
    roleName: '役割名',
    roleGroupName: '役割グループ名',
    roleGroupNameRequire: '役割グループ名を入力してください',
    roleGroupRequire: '役割グループを選択してください',
    roleNameRequire: 'ロール名を入力してください',
    noGroup: 'まだグループ化されていません',
    confirmDeleteTip: 'このユーザー ロールを削除してもよろしいですか?',
    confirmDeleteGroupTip:
      'このユーザー役割グループを削除してもよろしいですか?',
    addUser: 'メンバーを追加',
    authorization: '承認する',
    authorizeSuccess: '承認が成功しました',
    authorizeFail: '認証に失敗しました',
    selectRoleToAddUserTip: '左側でユーザーを追加するロールを選択してください',
    selectRoleToAuthorizeTip: '左側で承認された役割を選択してください',
    selectUser: 'ユーザーを選択してください',
    confirmDeleteUserTip: '次のユーザー ロールを削除することを確認します:|',
    notDeleteAdmin: 'スーパー管理者の管理者ユーザーは削除できません！'
  },
  param: {
    paramType: 'パラメータタイプ',
    paramName: 'パラメータ名',
    paramValue: 'パラメータ値',
    sortNo: 'ソート値',
    paramStatus: 'パラメータステータス',
    addParam: 'システム パラメータを追加する',
    updateParam: 'システム パラメータの変更',
    confirmDeleteTip: 'このシステム パラメータを削除してもよろしいですか？',
    typeRequire: 'システム パラメータ タイプを入力してください',
    nameRequire: 'パラメータ名を入力してください',
    valueRequire: 'システム パラメータ値を入力してください'
  },
  dictionary: {
    name: '名前',
    type: 'タイプ',
    dictName: '辞書名',
    dictType: '辞書の種類',
    value: '辞書の値',
    sortNo: 'ソート値',
    addDict: '辞書を追加',
    updateDict: '辞書を変更します',
    confirmDeleteTip: 'このデータ ディクショナリを削除してもよろしいですか？',
    nameRequire: '辞書名を入力してください',
    typeRequire: '辞書の種類を入力してください',
    valueRequire: '辞書の値を入力してください',
    sortNoRequire: '並べ替え値を入力してください'
  },
  announcement: {
    id: '#',
    title: '題名',
    content: '発表内容',
    validDate: '有効時間',
    modifiedDate: '時間を変更する',
    modifiedBy: '編集者',
    createdDate: 'リリース時間',
    createdBy: 'クリエイター',
    addDict: 'お知らせを追加',
    updateDict: '改正公告',
    beginTime: '始める',
    endTime: '終了',
    effectTime: '始める',
    expirationTime: '終了',
    addAnnouncement: 'お知らせを追加',
    deleteSure: 'このお知らせを削除してもよろしいですか?',
    modifyAnnouncemnet: '改正公告',
    choiceTime: '日時を選択',
    announcementStatus: '是否发布',
    inputTitle: 'タイトルを入力してください',
    inputContent: '内容を入力してください',
    inputTime: '時間を入力してください',
    titleMaxLength: '最大長は 50 です',
    contentMaxLength: '最大長は 500 です',
    nameMaxLength: '最大長は 30 です',
    announcementDetal: '発表内容',
    status: '状態',
    annRelease: '公開済み',
    annNotRelease: '未公開',
    releaseSuccess: '公開に成功しました',
    releaseFail: 'パブリッシュに失敗しました'
  },
  advice: {
    id: '#',
    advice: '推奨事項',
    reply: '返信内容',
    replyBy: '返信者',
    replyDate: 'ふっきじかん',
    status: '回復状態',
    createdDate: '作成時間',
    createdBy: '作成者',
    createTime: '作成時間',
    beginTime: '作成時間',
    endTime: '終了時間',
    replayStatus: '回復状態',
    replied: '返信済み',
    noReply: '返信なし',
    all: 'すべて',
    replayBtn: '返信',
    deleteBtn: '削除＃サクジョ＃',
    addAdvice: 'フィードバックしたい',
    adviceContent: '推奨事項',
    adviceReplay: '推奨される返信',
    advContent: '推奨事項',
    replayContent: '返信内容',
    deleteSure: 'この推奨項目の削除を確認しますか？'
  },
  loginLog: {
    loginLog: 'ログインログ',
    loginFailLog: 'ログイン失敗ログ',
    exitLog: '終了ログ',
    account: 'アカウント',
    time: '時刻',
    details: '結果',
    source: '送信元'
  },
  operatorLog: {
    logName: 'ログ名',
    operatorLog: '操作ログ',
    exceptionLog: '例外ログ',
    account: 'アカウント',
    className: 'オペレーションクラス名',
    methodName: '操作方法',
    msg: '具体的なメッセージ',
    result: '操作結果',
    costTime: '操作時間（ms）',
    time: '時刻'
  },
  account: {
    accountInfo: 'アカウント情報',
    modifyPwd: 'パスワードの変更',
    loginOut: 'ログオンの終了',
    account: 'アカウント',
    oldPwd: '元のパスワード',
    newPwd: '新しいパスワード',
    confirmNewPwd: '新しいパスワードの確認',
    oldPwdRequire: '元のパスワードを入力してください',
    newPwdRequire: '新しいパスワードを入力してください',
    confirmNewPwdRequire: '新しいパスワードを再入力してください',
    newEqualOld: '新しいパスワードは元のパスワードと同じです',
    newNotEqualNew: '2回のパスワード入力が異なる',
    modifyPwdSuccess: 'パスワードが更新されました！',
    newPasswordLength: 'パスワードの長さは 8 ～ 16 桁である必要があります',
    mustContain: '数字と文字を含める必要があります'
  },
  dstConfig: {
    colHeaderTip: '終了年が N/A の場合は、恒久的であることを意味します',
    dstName: '名前',
    timezone: 'タイムゾーン',
    startTime: '開始時間',
    endTime: '終了時間',
    startYear: '開始年',
    endYear: '年末年始',
    dstNameRequire: '夏時間の名前を入力してください',
    timezoneRequire: 'タイムゾーンを入力してください',
    startTimeRequire: '開始時間を入力してください',
    endTimeRequire: '終了時間を入力してください',
    startYearRequire: '開始年を入力してください',
    endYearRequire: '終了年を入力してください',
    active: '状態',
    addDstConfig: '夏時間の設定を追加',
    updateDstConfig: '夏時間設定の変更',
    confirmDeleteTip: 'この夏時間ルールを削除してもよろしいですか?',
    startTimeDesc:
      'MMIIWWHH、MM：月、II：週番号（01：第1週、02：第2週、03：第3週、04：第4週、11：最後から2週目） 、WW:週、HH:時間',
    endTimeDesc: '空の場合、永続的に有効であることを意味します'
  },
  enterprise: {
    orgType: '組織タイプ',
    orgList: '組織名',
    org: '組織名',
    orgDetail: '組織情報登録',
    deviceAssignment: 'デバイスの割り当て',
    organizationTypeId: '組織タイプ',
    orgCode: '部署コード',
    orgName: '部署名',
    orgManager: '部長',
    parentOrganizationCode: '上席部門コード',
    parentOrganizationName: '上席部門名',
    userManagement: '管理者登録'
  },
  enterprisedashboard: {
    clockStatus: 'デバイスの状態 ',
    employeeUpdate: '従業員状況 '
  },
  alcoholDetectionRecord: {
    pin: 'ID番号',
    name: '氏名',
    dataFromDevice: 'デバイス№',
    date: '検査日時',
    alcoholDegree: 'アルコール度数',
    drivingLicense: '運転免許証',
    healthStatus: '健康状態',
    sleepHours: '睡眠時間',
    licesnePlateNo: 'ナンバープレート',
    bodyTemparature: '体温',
    confirm: '確認者',
    comment: '備考欄'
  },
  employee: {
    employeeList: '従業員リスト',
    employeeDetail: '従業員情報詳細',
    employeeNo: '従業員番号',
    reqEmployeeNo: 'ジョブ番号を入力してください。',
    lastName: '氏名（ローマ字',
    reqLastName: '名前を入力してください',
    firstName: '姓（ラストネーム',
    reqFirstName: '姓を入力してください',
    formattedName: '氏名',
    photo: '写真',
    gender: '性別',
    email: '電子メール',
    phone: '電話番号',
    status: 'ステータス',
    active: 'アクティブ',
    employeeBasicInfo: '基本情報',
    employeeAttInfo: '確認',
    assignment: 'デバイスの割り当て',
    badgeNo: 'カード番号',
    devicePassword: 'パスワード',
    verifyingMode: '本人認証方式',
    devicePermission: 'アクセス許可',
    hireDate: '採用日付け',
    currentDept: '現在の部署の合計数は{0}です。',
    totalUser: '総数{0}人',
    addEmployee: '従業員の追加',
    updateEmployee: '従業員の更新',
    selectOrgTip: '人を追加する前に、組織構造を選択してください',
    deleteEmployee: '本当にその従業員を削除する？続行する？',
    downloadTemplate: 'テンプレートのダウンロード',
    importEmployee: '従業員をインポート',
    exportEmployee: '従業員をエクスポート',
    drivingStart: '運転免許証交付日',
    drivingEnd: '運転免許有効日',
    enteredFingerprint: 'フィンガープリントの入力',
    notEnteredFingerprint: '指紋未入力',
    enteredVisibleLight: '可視光線未入力',
    enteredNirFace: '近赤外線入力済み',
    notEnteredNirFace: '近赤外線未入力',
    enteredPalmPrint: '掌紋が入力されています',
    notEnteredPalmPrint: '掌紋外未入力'
  },
  licensePlate: {
    num: 'ナンバープレート',
    alias: '車両管理番号(任意)',
    employeeNo: 'ライセンスプレート番号',
    reqLicensePlateNo: 'ジョブナンバーを入力してください。',
    lastName: '名',
    reqLastName: '姓を入力してください',
    firstName: '姓',
    reqFirstName: '名を入力してください',
    formattedName: '名前',
    photo: '写真',
    gender: '性別',
    email: '電子メール',
    phone: '電話番号',
    status: 'ステータス',
    active: 'アクティブ',
    employeeBasicInfo: '基本的な',
    employeeAttInfo: '確認',
    assignment: 'デバイスの割り当て',
    badgeNo: 'カード番号',
    devicePassword: 'パスワード',
    verifyingMode: '認証',
    devicePermission: 'アクセス許可',
    hireDate: '採用日付け',
    currentDept: '現在の部署の合計数は{0}です。',
    totalUser: '合計{0}件',
    addLicensePlate: 'ナンバープレートの追加',
    updateLicensePlate: 'ナンバープレートを更新する',
    selectOrgTip: '人を追加する前に組織構造を選択してください',
    deleteLicensePlate:
      '本当にその従業員を削除しますか？続行しますか？',
    downloadTemplate: 'テンプレートのダウンロード',
    importLicensePlate: 'ライセンスプレートのインポート',
    exportLicensePlate: 'ライセンスプレートのエクスポート',
    checkImportOrganization:
      '本当にここにナンバープレートをインポートしますか？',
    successTotal: '成功した合計数'
  },
  devicePermission: {
    '0': '通常ユーザー',
    '7': 'フィールド管理者',
    '14': 'デバイス管理者'
  },
  integrators: {
    addIntegrators: '新規アカウント',
    confirmFreeze: 'ユーザーのフリーズ'
  },
  findpassword: {
    verifyAccount: 'アカウントの確認',
    verifyCode: '認証コードの確認',
    resetPassword: 'パスワードのリセット',
    success: 'リセット成功'
  },
  attendanceCode: {
    laborCodes: '勤怠コード',
    laborCodesType: '勤怠コード',
    laborCodeDeatils: '出勤簿の詳細',
    newOrgCode: '追加 ',
    requireLaborCodes: '勤怠管理コードを入力してください',
    requireLaborCodesName: '勤怠管理コード名を入力してください',
    requirelaborCodesType:
      '勤怠作業コードの種類を入力してください',
    requireLaborCodesTypeName:
      '勤怠管理コードの種類名を入力してください',
    attendanceCodeList: 'コード一覧',
    code: '勤怠作業コード',
    assignment: 'デバイスの割り当て',
    unBindWordCode: 'バインドを解除してよろしい？'
  },
  devicesCommand: {
    comId: '操作者ID',
    sn: 'デバイス№',
    imme: '緊急事態の有無',
    protocol: 'プロトコル',
    content: '内容',
    committime: '時刻',
    returnTime: '返信時間',
    status: '状態',
    returnValue: '戻り値',
    status0: '持ち去られていない',
    code: 'コード',
    status1: '返信がないまま持ち去られた',
    status2: '返信あり',
    status3: 'クリア',
    result: '結果',
    success: '成功',
    fail: '失敗',
    commandResult: '結果',
    all: '全て',
    ratchResend: '一括再送信',
    sendCommandsTip:
      '合計{length}個のコマンドが選択されています。選択されたコマンドを再送信しますか？',
    sendCommandTip: 'コマンドを再送信しますか？'
  },
  contry: {
    AD: 'アンドラ',
    AE: 'アラブ首長国連邦',
    AF: 'アフガニスタン',
    AG: 'アンティグア・バーブーダ',
    AI: 'アンギラ',
    AL: 'アルバニア',
    AM: 'アルメニア',
    AO: 'アンゴラ',
    AR: 'アルゼンチン',
    AT: 'オーストリア',
    AU: 'オーストラリア',
    AZ: 'アゼルバイジャン',
    BB: 'バルバドス',
    BD: 'バングラデシュ',
    BE: 'ベルギー',
    BF: 'ブルキナファソ',
    BG: 'ブルガリア',
    BH: 'バーレーン',
    BI: 'ブルンジ',
    BJ: 'ベナン',
    BL: 'パレスチナ',
    BM: 'バミューダ',
    BN: 'ブルネイ',
    BO: 'ボリビア',
    BR: 'ブラジル',
    BS: 'バハマ',
    BW: 'ボツワナ',
    BY: 'ベラルーシ',
    BZ: 'ベリーズ',
    CA: 'カナダ',
    CF: '中央アフリカ共和国',
    CG: 'コンゴ共和国',
    CH: 'スイス',
    CK: 'クック諸島',
    CL: 'チリ',
    CM: 'カメルーン',
    CN: '中国',
    CO: 'コロンビア',
    CR: 'コスタリカ',
    CS: 'チェコ共和国',
    CU: 'キューバ',
    CY: 'キプロス',
    CZ: 'チェコ共和国',
    DE: 'ドイツ',
    DJ: 'ジブチ',
    DK: 'デンマーク',
    DO: 'ドミニカ共和国',
    DZ: 'アルジェリア',
    EC: 'エクアドル',
    EE: 'エストニア',
    EG: 'エジプト',
    ES: 'スペイン',
    ET: 'エチオピア',
    FI: 'フィンランド',
    FJ: 'フィジー',
    FR: 'フランス',
    GA: 'ガボン',
    GB: 'イングランド',
    GD: 'グレナダ',
    GE: 'グルジア',
    GF: 'フランス領ギアナ',
    GH: 'ガーナ',
    GI: 'ジブラルタル',
    GM: 'ガンビア',
    GN: 'ギニア共和国',
    GR: 'ギリシャ',
    GT: 'グアテマラ',
    GU: 'グアム',
    GY: 'ガイアナ',
    HK: '香港特別行政区',
    HN: 'ホンジュラス',
    HT: 'ハイチ',
    HU: 'ハンガリー',
    ID: 'インドネシア',
    IE: 'アイルランド',
    IL: 'イスラエル',
    IN: 'インド',
    IQ: 'イラク',
    IR: 'イラン',
    IS: 'アイスランド',
    IT: 'イタリア',
    JM: 'ジャマイカ',
    JO: 'ヨルダン',
    JP: '日本',
    KE: 'ケニア',
    KG: 'キルギスタン',
    KH: 'カンボジア',
    KP: '北朝鮮',
    KR: '韓国',
    KT: 'コートジボワール共和国',
    KW: 'クウェート',
    KZ: 'カザフスタン',
    LA: 'ラオス',
    LB: 'レバノン',
    LC: 'セントルシア',
    LI: 'リヒテンシュタイン',
    LK: 'スリランカ',
    LR: 'リベリア',
    LS: 'レソト',
    LT: 'リトアニア',
    LU: 'ルクセンブルク',
    LV: 'ラトビア',
    LY: 'リビア',
    MA: 'モロッコ',
    MC: 'モナコ',
    MD: 'モルドバ',
    MG: 'マダガスカル',
    ML: 'マリ',
    MM: 'ビルマ',
    MN: 'モンゴル',
    MO: 'マカオ',
    MS: 'モントセラト',
    MT: 'マルタ',
    MU: 'マウリティアス',
    MV: 'モルディブ',
    MW: 'マラウイ',
    MX: 'メキシコ',
    MY: 'マレーシア',
    MZ: 'モザンビーク',
    NA: 'ナミビア',
    NE: 'ニジェール',
    NG: 'ナイジェリア',
    NI: 'ニカラグア',
    NL: 'オランダ',
    NO: 'ノルウェー',
    NP: 'ネパール',
    NR: 'ナウル',
    NZ: 'ニュージーランド',
    OM: 'オマーン',
    PA: 'パナマ',
    PE: 'ペルー',
    PF: 'フランス領ポリネシア',
    PG: 'パプアニューギニア',
    PH: 'フィリピン',
    PK: 'パキスタン',
    PL: 'ポーランド',
    PR: 'プエルトリコ',
    PT: 'ポルトガル',
    PY: 'パラグアイ',
    QA: 'カタール',
    RO: 'ルーマニア',
    RU: 'ロシア',
    SA: 'サウジアラビア',
    SB: 'ソロモン諸島',
    SC: 'セイシェル',
    SD: 'スーダン',
    SE: 'スウェーデン',
    SG: 'シンガポール',
    SI: 'スロベニア',
    SK: 'スロバキア',
    SL: 'シエラレオネ',
    SM: 'サンマリノ',
    SN: 'セネガル',
    SO: 'ソマリア',
    SR: 'スリナム',
    ST: 'サントメ・プリンシペ',
    SV: 'サルバドル',
    SY: 'シリア',
    SZ: 'スワジランド',
    TD: 'チャド',
    TG: 'トーゴ',
    TH: 'タイ',
    TJ: 'タジキスタン',
    TM: 'トルクメニスタン',
    TN: 'チュニジア',
    TO: 'トンガ',
    TR: 'トルコ',
    TT: 'トリニダード・トバゴ',
    TW: '台湾省',
    TZ: 'タンザニア',
    UA: 'ウクライナ',
    UG: 'ウガンダ',
    US: 'アメリカ',
    UY: 'ウルグアイ',
    UZ: 'ウズベキスタン',
    VC: 'セントビンセント',
    VE: 'ベネズエラ',
    VN: 'ベトナム',
    YE: 'イエメン',
    YU: 'ユーゴスラビア',
    ZA: '南アフリカ共和国',
    ZM: 'ザンビア',
    ZR: 'ザイール',
    ZW: 'ジンバブエ'
  },
  tenantDashboard: {
    tenants: '企業情報統計',
    newEnrolled: '新規参入企業',
    inactive: '「無効」'
  },
  dashboard: {
    dataFormste: '{value｝日',
    onlineDevice: 'オンラインデバイス',
    offLineDevice: 'オフラインデバイス',
    disableDevice: '無効化されたデバイス',
    deviceTypetop10: 'デバイスの種類トップ10',
    addDeviceBar: '新規デバイスのラインチャート',
    areaDeviceTop10: 'エリアデバイストップ10',
    globalDeviceDis: 'グローバルデバイス分布',
    addDevice: 'デバイスを追加する',
    device: 'デバイス'
  },
  apiLog: {
    mid: '中間',
    companyUser: '統合アカウント',
    requestMessage: 'リクエストメッセージ',
    responseMessage: '応答メッセージ',
    ip: 'IP',
    createDate: 'リクエスト日',
    requestResult: 'リクエスト結果',
    result: '結果',
    useTime: '配信時間',
    url: 'URL',
    apiLog: 'APIログ',
    requestTime: 'リクエスト時間',
    appKey: 'キー',
    success: '成功',
    fail: '失敗',
    apiName: 'アプリ名',
    elapsedMs: '経過時間',
    requestContent: 'リクエスト内容',
    statusCode: 'ステータスコード',
    copySucess: 'コピーに成功しました',
    copyError:
      'レプリケーションはサポートされていません。このブラウザは自動レプリケーションをサポートしていません',
    copy: 'コピー',
    appCode: 'アプリコード',
    dbs: 'スマートDBS',
    cc: '控制中心',
    ufo: '固件升级',
    appName: 'アプリ名',
    method: '要求の方法'
  },
  datapush: {
    appList: 'アプリ一覧',
    dataList: 'データ一覧',
    pushLoad: 'プッシュデータ',
    message: 'メッセージ内容',
    lastPushTime: '最終プッシュ時刻',
    num: '試行回数',
    asyPushTip: '非同期でデータをプッシュしている',
    pushbtnTip: '中継データの非同期プッシュを適用する',
    sid: 'プッシュイベント',
    mid: '中間',
    total: '合計',
    success: '成功',
    fail: '失敗',
    pushURL: 'プッシュURL',
    dataType: 'データの種類',
    dataPeriod: 'データの保持期間',
    lastPushStatus: '最終プッシュ状況'
  },
  goBack: '戻る',
  goLoginPage: 'ログインページ',
  orgTree: {
    parentCode: '上席部門コード',
    parentCodeTip: '上位部門コードを入力してください。',
    parentName: '上席部門名',
    parentNameTip: '上位部門名を入力してください',
    deptCode: '部門コード',
    deptCodeTip: '部門コードを入力してください',
    deptName: '部署名',
    deptNameTip: '部門名を入力してください',
    add: '部門を追加する',
    update: '部門を更新する',
    execute: '実行...',
    createOrg: '組織構造の作成に成功した',
    updateOrg: '組織構造の更新に成功した',
    ownerDept: '部門'
  },
  header: {
    enterCompanyName: '会社名を入力してください',
    enterAppName: 'アプリケーション名を入力してください',
    online: 'オンライン',
    offline: 'オフライン',
    selectApp: 'アプリケーションを選択してください',
    all: 'すべて',
    createApp: 'アプリケーションを追加する ',
    selectCompany: '会社を選択してください',
    createCompany: '会社を追加',
    companyCode: '企業番号',
    companyName: '企業名',
    reqName: '会社名を入力してください',
    reqNo: '企業番号を入力してください'
  },
  configType: {
    pushType: 'プッシュタイプ',
    name: 'の名前をあげる',
    toPush: 'プッシュ',
    turnOn: '開く',
    turnOff: '閉じる',
    desc: '説明',
    operate: '操作',
    only: 'プッシュメッセージの種類を表す一意な識別子',
    queue: '列',
    sort: 'ソート',
    reqName: '名前を入力してください',
    reqSid: 'sidを入力してください',
    maxLength: '最大長さは50ワードです',
    reqQueue: '列を選択してください',
    addConfig: '設定を追加する',
    updateConfig: '設定を更新',
    deleteConfig:
      'これを削除すると、 このタイプのアプリのプッシュメッセージはすべて閉じられる。 本当に削除してよい？'
  },
  developer: {
    randomNote:
      'トークンは鍵の一部であり、デジタルサインダイジェストの生成に使用されます。',
    randomNote16:
      'キーはデータプッシュリクエストのコンテンツを 暗号化するために使用される。',
    pushIntroduce:
      'DBSがお客様の連携システムサービスへデータをプッシュすることを許可します。',
    employeNum: '従業員数',
    paramsCongig: 'パラメータ設定',
    immCreate: '追加',
    noApp:
      '「You do not have an app yet, add it!」 と表示されます。',
    companyNum: '企業',
    appNumber: 'アプリ番号',
    dicTypePla: '辞書名の種類を入力してください',
    dicNamePla: '辞書名を入力してください',
    enterApp: '入力',
    deleteApp: '削除',
    withdrawApp: 'リストア',
    withdrawTip: '本当にアプリケーションを復元する？',
    withdrawAppSuccess: 'リストア成功',
    destroyApp: '完全削除',
    destroyAppSuccess: '完全削除成功した',
    destroySure:
      'アプリケーションが完全に削除された後、関連するデータは直接削除され、復元できなくなる。 削除する?',
    WithdrawSure:
      'アプリケーションを復元すると、 アプリケーションの一覧に戻る。 復元する？',
    name: 'アプリケーション名',
    dashboard: 'ダッシュボード',
    appDeatil: '詳細',
    pushSetting: 'データプッシュ設定',
    dataTransferStation: 'データプッシュメンテナンス',
    apiLog: 'APIログ',
    deviceTotle: 'すべてのデバイス',
    offlineCount: 'オフラインデバイス',
    onLineCount: 'オンラインデバイス',
    relayNum: '乗換駅メッセージ',
    selectDataType: 'データの種類を選択する',
    goAppList: '戻る',
    cancel: 'キャンセルする',
    cancelWithdrawApp: '操作をキャンセルする',
    goback: '戻る',
    selectType: '種類を選ぶ',
    companyAdmin:
      '企業内管理者プラットフォームは、開発者がプラットフォームの下で、企業のアカウント作成および管理することを許可します。 このアカウントは、プラットフォームにログインして、企業、人員、および機器の運用を管理できます。 デフォルトでは有効になっていません。',
    companySettingDes:
      '企業内管理者プラットフォームは、開発者がプラットフォームの下で、企業のアカウント作成および管理することを許可します。このアカウントは、プラットフォームにログインして、企業、人員、および機器の運用を管理できます。デフォルトでは有効になっていません。',
    appFnSetting: 'アプリケーション設定',
    pushDes: '説明',
    changeWay: '切替え',
    appDes: 'アプリケーションの説明',
    newsSub: 'ニュース配信',
    dataTransfer: 'データ転送する',
    abnormalRemind: 'アブノーマル リマインダ',
    remindSet: 'リマインド設定する',
    remindSet1: '数時間、メッセージが積み重なってる',
    remindSet2: '項目',
    apiReport: 'APIレポート',
    receiveMail: 'メールを受信する',
    statisticsRemind: '統計リマインダ',
    statisticsReport: '統計レポート',
    daily: '日報',
    dailyTips: '毎日のデータは前日のデータ',
    week: '週報',
    weekTips:
      '週報のデータは前週のデータであり、毎週月曜日にプッシュされます',
    month: '月次報告',
    monthTips:
      '月報データは前月のデータであり、毎月1日にプッシュされます',
    mailSetMax: '受信メールボックスの数が上限に達しています',
    appName: 'アプリケーション名',
    developerAccount: '開発者アカウント',
    assApplication: '関連するアプリケーション',
    config: '設定',
    newEmail: '新規メール',
    changeEmail: 'メール変更',
    isOk: 'はい',
    createAppSucess: 'アプリケーションの作成に成功しました',
    visiable: '見える',
    disvisible: '見えない',
    updateApp: 'アプリの更新',
    deleteTips:
      ' アプリケーションを削除した後、ごみ箱に入ります。  アプリのデータを消去したい場合は、ごみ箱で完全削除してください',
    lastQuest: '最後のアクティブ時間',
    aeskeyPla: '暗号化キーを入力してください',
    tokenPla: 'トークンを入力してください',
    desPla: 'アプリケーションの説明を入力してください',
    phonePla: '携帯の電話番号を入力してください',
    contactPerPla: '担当者を入力してください',
    appEmailPla: 'メールアドレスを入力してください',
    appNamePla: 'アプリケーション名を入力してください',
    appList: 'アプリ一覧',
    appInfo: 'アプリ情報',
    details: '詳細',
    setting: '設定',
    addApp: 'アプリを追加する',
    deleApp: 'アプリを削除する',
    id: 'ID',
    code: 'コード',
    des: 'アプリケーションの内容',
    contactPerson: '連絡先',
    mail: 'メールアドレス',
    phone: '電話番号',
    appKey: 'AppKey',
    appSecret: 'アプリシークレット',
    pushDerail: 'プッシュスイッチ',
    url: 'URL',
    token: 'Token',
    aeskey: '暗号化された秘密キー',
    aesStatus: 'データの暗号化した',
    eventTypeArray: 'プッシュデータカテゴリ',
    serviceConfig: 'データプッシュの構成',
    requireName: 'アプリケーション名を入力してください',
    appNameLength: '最大文字数は16文字',
    requireMail: 'メールアドレスを入力してください',
    requireCode: '認証コードを入力してください',
    randomCode: 'ランダムアクセスコードの作成',
    reset: 'リセット',
    saveTip: 'セービング',
    resetTip: 'appSecretのリセットは本当にしていますか？',
    pushPunchRecordFunOn: '出欠席の記録',
    pushPhoto: '勤怠写真',
    pushDeviceInitFunOn: 'デバイスの初期化',
    pushRegisterFpTipFunOn: '指紋登録',
    pushDeviceStatusFunOn: 'デバイスの状態',
    validateUrl: 'テスト接続',
    urlTip: '有効なURLを入力してください',
    urlEg: '例）https://www.zkteco.com/',
    emainValidate: '正しいメールアドレスを入力してください'
  },
  doc: {
    apiDoc: 'APIドキュメント',
    faq: 'よくある質問',
    version: 'バージョン情報',
    operate: 'オペレーションハンドブック',
    tenant: 'テナント向けドキュメント',
    developer: 'デベロッパー向け資料',
    enterpriseAdmin: '企業管理者用資料'
  },
  operationMsg: {
    uploadSuc: 'アップロードに成功',
    updateSuc: '修正成功',
    bindSuc: 'バインディング成功',
    addSuc: '追加に成功',
    sendSuc: '送信に成功した',
    importSuc: 'インポート成功した',
    deleteSuc: '削除に成功した'
  },
  sysTemplate: {
    type: 'タイプ',
    title: 'タイトル',
    templateName: '名前',
    content: '内容',
    group: 'グループ名',
    languange: '言語',
    satatus: 'ステータス',
    create: '作成者',
    createData: '作成日',
    update: '修正者',
    updateData: '変更日',
    delteTemplate: 'テンプレートを削除して よろしい？',
    editTemp: 'テンプレートエディター',
    viewTemp: 'テンプレートプレビュー',
    addTemp: 'テンプレートを追加する',
    tempTips1: 'テンプレートの例',
    tempTips2:
      '({number} はカスタマイズ可能で、 {0}, {1} などのように0から連続した番号 である必要がある)',
    sign: '署名',
    inputCode: 'テンプレートコードを入力してください',
    inputType: 'テンプレートの種類を入力してください',
    inputLang: 'テンプレートの言語を入力してください',
    inputName: 'テンプレート名を入力してください',
    inputTitle: 'テンプレートのタイトルを入力してください',
    inputContent: 'テンプレートの内容を入力してください',
    inputGroup: 'テンプレートのグループ化を入力してください'
  },
  wxbind: {
    unbindWx: 'WeChatのバインドを解除する',
    unbindWxTips:
      'このアカウントのバインドを解除する。このまま続ける？',
    bindPhoneSuc: '携帯電話のバインドを成功した'
  },
  center: {
    isGoOn: '続行する',
    isNotBind:
      'まだメールをバインドしていない。 まずパーソナルセンターでメールをバインドしてください。',
    disposeAccountTips:
      'この操作により、アカウントがキャンセルされる。 ログアウトすると、再度ログインすることはできなくなる。 SMARTDBS は、アカウントに関連するすべてのデータも消去する。 ご注意ください！',
    deal: 'プライバシー規約',
    policy: 'プライバシーポリシー',
    clickShow: 'クリックして表示',
    disposeAccount: 'アカウントを閉じる',
    verPhone: '正しい携帯電話番号を入力してください',
    weakPwd:
      '使用したパスワードには数字または文字が含まれていない。 リセットしてください!',
    centerpage: 'パーソナルセンター',
    basicInfo: '基本情報',
    socialAccount: 'ソーシャルアカウントをバインドする',
    noBindEmail: 'メールボックスがバインドされていない',
    noBindPhone: '携帯電話のバインド解除する',
    valWay: '電話/メールアドレスの変更には認証が必要',
    valEmail: 'メール認証',
    valPhone: '電話認証',
    reGetCode: '秒',
    getCode: 'コードを取得',
    code: 'コード',
    plaCode: '認証コードを入力してください',
    plaPhone: '携帯電話番号を入力してください。',
    plaSureEmail: '正しいメールアドレスを入力してください。',
    plaEmail: 'メールアドレスを入力してください',
    auth: '認証方法',
    updateNicknameSuc: 'ニックネームの変更に成功した',
    plaContent: '内容を入力してください',
    updateWetchat: 'weChatを修正する',
    nobindWetchat: 'バインド解除をクリック',
    updatePassword: 'パスワードを変更する',
    updatePhone: '電話番号を変更する',
    bindPhone: '電話をバインドする',
    updateEamil: 'メールを変更する',
    bindEmail: 'メールをバインドする',
    bindWetchat: 'WeChatのバインド',
    password: 'パスワード',
    phone: '電話番号',
    email: '電子メール',
    headImg: 'アバター',
    nickName: 'ニックネーム',
    account: 'アカウント名',
    wetchat: 'WetChat',
    expirationDate: '有効期限'
  },
  appSetting: { deviceCommand: 'デバイスコマンド' },
  pushStation: { errorRecord: '例外の記録' },
  deviceEmp: {
    bindEmp: '人員にバインドをする',
    deviceBindEmp: '人員にバインドを？',
    orgTree: '組織構成',
    empList: '人員リスト',
    selectDevice: 'デバイスを選択してください',
    unbindDevice:
      'この操作により、デバイスがアンタイされる。 続けたい？',
    unbindSuc: 'デバイスは正常にアンバンドルされた',
    unbindCan: 'バインド解除がキャンセルされた',
    hasDevice: 'デバイスの存在を確認してください'
  },
  empList: {
    lostImport: '一括インポート',
    choiseFile: 'ファイルを選択する',
    extName: '拡張機能のサポート',
    extTip: '.xlsx または .xls',
    finishImport: '一括インポート完了',
    beginImport: 'インポート開始',
    finish: '終了',
    onlyXLSL: '.xLSLファイル形式のみ対応される'
  },
  attRecord: { temperature: '温度', hasMask: 'マスク' },
  companyList: {
    selectApp: 'アプリを選択してください',
    deletCompany:
      'このアクションは、会社を永久に削除する。 続行する？'
  },
  annList: {
    sendEmail: 'メール送信',
    dev: '開発者',
    ent: '企業の管理者 ',
    sureRelase: 'このシステム発表を公開してもよろしい?'
  },
  com_log: {
    tipMsg:
      '過去30日間のデバイス通信活動に関するサポートサービスを含みます。',
    nearlyDays7: '7日以内',
    search: '検索',
    eventTime: 'イベント時間',
    protocol: 'プロトコル',
    sn: 'SN',
    type: 'イベントタイプ',
    mid: 'メッセージID',
    funcName: '機能名',
    loadMore: '読み込み中 More',
    content: 'コンテンツ',
    associatedLog: '関連するログ',
    result: '結果',
    success: '成功',
    fail: '失敗',
    inputSn: 'SNを入力してください',
    inputMid: 'メッセージIDを入力してください',
    selectProtocol: 'プロトコルを選択してください',
    selectEventType: 'EventTypeを選択してください',
    selectFuncName: '機能名を選択してください',
    selectResult: '結果を選択してください'
  },
  device: {
    com_log: '通信記録',
    uploadAtt: '出勤簿のアップロード',
    uploadUserInfo: 'ユーザーデータのアップロード',
    synData: 'ユーザーデータの端末への同期',
    network: 'ネットワーク',
    deviceUser: '機器の使用状況',
    deviceCommand: '機器コマンド',
    deviceSelectPla: 'デバイスの状態を選択してください',
    deviceSetting: 'デバイスの設定',
    deviceParamsDesc: 'パラメータを記述する',
    deviceNum: 'デバイス数（オンライン/全体）',
    firmwareUpgrade: 'ファームウェアを更新する',
    snycUser:
      'DBS は個人情報をデバイスにプッシュし、デバイス データを上書きますが、続けてよろしい？',
    uploadUser:
      'デバイス内の人員情報がDBSにアップロードされる。続けてよろしい？',
    hasNODevice: '機器なし、操作なし！',
    sn: 'デバイスNo.',
    name: 'デバイスの種類。',
    alias: 'デバイス名',
    deviceList: 'リスト ',
    deviceDetails: 'デバイス',
    deviceInfo: 'デバイス',
    deviceConInfo: 'ネットワーク接続',
    deviceRunSysInfo: 'システム情報。',
    addDevice: 'デバイスの追加',
    modifyDevice: 'デバイスを更新する。',
    snRequire: 'snを入力してください。',
    maxLength: '最大入力値は35',
    maxLength20: '最大入力値は20',
    devAlais: 'デバイス名を入力してください。',
    assignDevice: 'デバイス割当',
    selectDeivces: 'デバイスを選択してください。',
    selectUnBindDevice:
      'バインドを解除するデバイスを選択してください',
    selectDept: 'バインドの組織を選択する',
    unBindDept: '本当にバインドを解除する？',
    unBindBtn: '割当て解除',
    setEmployeeBind:
      '現在の従業員は本当に選択したデバイスにバインドする?',
    deviceOperate: 'デバイスの操作',
    confirmDeleteTip: 'このデバイスを削除してよろしい？',
    deleteBioTemplate: 'テンプレートを削除してよろしい？',
    deviceModel: 'デバイスのモデル。',
    deviceTimezone: 'タイムゾーン',
    active: 'アクティブ。',
    connectionMode: 'ネットワークモード。',
    localIp: 'イントラネットip',
    macAddress: 'MACアドレス',
    remoteIp: '公衆ネットワークIP',
    ipLocation: '位置',
    firmwave: 'ファームウェアのバージョン',
    commProtocol: 'プロトコル',
    commProtocolVer: 'プロトコルのバージョン',
    systemPlatform: 'オペレーティングシステム',
    osVersion: 'OSバージョン',
    storageSize: 'ストレージサイズ',
    storageFreeSize: 'メモリ残量',
    employeeCount: '従業員',
    fpCount: '指紋',
    faceCount: '顔',
    fvCount: '近赤外線の顔',
    attlogCount: '勤怠の記録',
    lastRequest: '最終リクエスト時間',
    status: 'ステータス',
    totalDevice: '合計',
    online: 'オンライン',
    disbaleDevice: '無効にする',
    offLine: 'オフライン',
    reboot: 'デバイスを再起動する？',
    disabled: 'デバイスを無効にしてよろしい？',
    dataRange: '時間範囲',
    uploadAttData: '勤怠データをアップロードする。',
    code: '勤怠管理コード,',
    Timezone: 'デバイスのタイムゾーン,',
    deviceStatus: '状態',
    onlineStatus: 'オンライン',
    enableStatus: '有効',
    equipmentStatus: '状態',
    offLineTip:
      'デバイスはオフライン。操作は許可されていない。',
    enableTip: 'デバイスは無効。操作は許可されていない。',
    deviceEmploye: '社員',
    deviceHistoryLog: 'ログ',
    deviceConfig: 'パラメータの設定',
    deviceParams: 'デバイス パラメータ',
    deviceParamsValue: '値です。',
    noPermission: 'デバイスを追加する権限がない。',
    deviceOptions: 'パラメータ, ',
    version: 'バージョン',
    firmwaveSize: 'サイズ',
    description: '説明',
    noInfo: '説明文がない。',
    upgrade: 'アップグレードしてください。',
    retry: '再試行してください。',
    upgradeFailed: 'アップグレードに失敗した。',
    beingUpgraded: 'デバイスをアップグレード中',
    burningFirmware: 'ファームウェアの書き込み中',
    upgradeSuccessful: 'アップグレードに成功した。',
    downloadingFirmware:
      "ファームウェアを'デバイスにダウンロードしている、しばらくお待ちください。",
    deviceInternet:
      'デバイスの電源が入り、インターネットに接続されていることを確認してください。',
    sizeTip: '不明',
    memoryRemaining: 'メモリ残量,',
    storageRemaining: 'Storage Remaining（ストレージの残り）。',
    log: {
      userName: 'オペレーター',
      companyName: '企業名',
      requestParams: 'パラメーター',
      createdDate: '操作時間',
      methodType: '操作の種類。'
    },
    biosignature: 'バイオシグネチャ',
    devType: 'デバイスタイプ',
    deviceCategory: 'デバイスカテゴリ',
    dataOperation: 'データ操作',
    removeOldData: '古いデータを消去しない',
    synInfo: '同期情報',
    baseInfo: '人事基本情報',
    bioTemplateInfo: '生体テンプレート',
    facePhotoInfo: '人物の顔写真',
    synTip:
      '同期情報が送信されました。システムは実行中です。後ほど端末でご確認ください',
    synbtn: '同期',
    updateAllDevice: '全機器のアップグレード',
    allCount: '全機器',
    canUpgradeCount: 'アップグレード対象機器数',
    noNeedUpgradeCount: 'アップグレード不要',
    upgradingCount: 'アップグレード中',
    updateConfirm: '本当にアップグレードしますか？',
    updateTip:
      'アップグレードコマンドが発行されました。詳細はアップグレード履歴をご確認ください',
    updateText:
      '機器のアップグレード中は、電源やネットワークを遮断しないようにしてください。アップグレードの進行状況は、アップグレード履歴で確認することができます。',
    updateHistory: 'アップグレード履歴',
    upgrading: 'アップグレード中',
    upgradeSuccess: 'アップグレード成功',
    upgradeError: 'アップグレード失敗',
    downloading: 'ダウンロード中',
    fire: '焼成中',
    upgradeTimeout: 'アップグレードのタイムアウト',
    updateDetails: 'アップグレードの詳細',
    source: '操作元',
    lastVersion: '旧バージョン',
    currentVersion: '現状のバージョン',
    serviceUpdate: 'サーバー側のアップグレード',
    clientUpdate: 'デバイス側のアップグレード',
    dbsUpdate: 'DBSアップグレード'
  },
  license: {
    curLicense: '現在のライセンス情報',
    licenseStatus: '国家ライセンス',
    licentseValidity: 'ライセンスの有効期限',
    deviceMax: 'デバイスの上限',
    curDevice: '現在のデバイス数',
    newsLicense: '最新のオンラインライセンス申請情報',
    aduitStatus: 'ステータスの確認',
    applyDevice: '申請した機器の台数',
    applyDate: '申し込みの有効性',
    remark: '備考',
    approvalTime: '認可時間',
    custormInfo: 'お客様情報',
    custormNo: 'お客様番号',
    custormContact: '連絡先',
    custormPhone: '電話番号',
    custormEmail: '電子メール',
    custormCompany: '会社名',
    onlineLicense: 'オンライン申請',
    offlineLicense: 'オフラインで申請する',
    importLicense: 'インポートライセンス',
    titles: 'プロンプト',
    uploadTips1: 'ファイルをここにドラッグするか',
    uploadTips2: 'アップロードをクリックしてください。',
    year: '年',
    save: '保存',
    reset: 'リセット',
    noUpdate: 'スキップする',
    tips:
      '注意事項 申請前情報は審査時の参考資料であり、具体的なデータが優先されます。',
    updateTips:
      '注意事項 この[ライセンス申請コード]をコピーして、ライセンス管理者にライセンスファイルを要求し、それをインポートしてライセンスのアップグレードを完了させる。',
    deviceNum: 'デバイス数',
    apply: '有効期限',
    applyCode: 'ライセンス申請コード',
    copy: 'ワンキーでクリップボードにコピー',
    inputContant: '担当者を入力してください',
    inputPhone: '携帯電話番号を入力してください',
    inputEmail: 'メールアドレスを入力してください',
    inputCompany: '会社名を入力してください',
    inputDevice: '端末の台数を入力してください',
    inputApply: '有効期限を入力してください',
    copySuc: 'クリップボードにコピーされました',
    applySuc: '申請成功'
  },
  statistics: {
    lastSevenDays: '最後の7日間',
    lastMonth: '過去1ヶ月間',
    lastThreeMonths: '過去3ヶ月間',
    more: 'もっと見る',
    apiSort: 'インターフェイス通話ランキング',
    apiStatistics: 'インターフェイス通話統計',
    todayCallsTotal: '本日の集計',
    todayCallsSort: '本日のランキング',
    today: '本日',
    months: {
      month01: '1月',
      month02: '2月',
      month03: '3月',
      month04: '4月',
      month05: '5月',
      month06: '6月',
      month07: '7月',
      month08: '8月',
      month09: '9月',
      month10: '10月',
      month11: '11月',
      month12: '12月'
    },
    url: 'URI',
    apiName: 'API名',
    callCount: 'コール数',
    interfaceCallCount: 'インターフェース呼出し回数',
    callDetail: '呼び出しの詳細',
    appKey: 'アプリキー',
    appName: 'APP名',
    callTimes: 'コール{count}回数',
    apiCallDetail: 'APIコール詳細',
    appCallDetail: 'APPコールの詳細',
    name: '名称'
  },
  accManager: {
    doorName: 'ドア名',
    devAlias: '所属デバイス',
    devStatus: '状態',
    doorList: 'ドアリスト',
    timeSlot: 'アクセス制御期間',
    permissionGroup: 'アクセス制御許可グループ',
    timezoneName: 'タイムピリオド名',
    timeSlotDetails: '時間帯の詳細',
    holiday1: '休日1',
    holiday2: '休日1',
    holiday3: '休日1',
    groupName: 'パーミッショングループ名',
    timezone: '時間帯',
    distributionDoor: '配布先',
    distributionPersonnel: '配信担当者',
    number: '番号',
    name: '名称',
    daterange: '日付'
  },
  successOperation: {
    delete: '删除成功',
    add: '新增成功',
    sendCode: '検証コードが送信さした',
    sendEmail: 'メール送信成功した',
    reset: 'AppSecretのリセットに成功した',
    update: 'アップデートに成功した',
    cancellationSuccess: '取り消しを成功した'
  },
  errorOperation: {},
  warningOperation: {
    hasPhoneOrEmail:
      '携帯電話や電子メールがバインドされていないため、まずはバインドしてください。'
  },
  operation: {
    addNew: '追加する ',
    save: '保存する',
    confirm: '確認する',
    saving: '保存する...',
    checkAll: 'すべてをチェック',
    search: '検索する',
    freeze: 'フリーズ',
    unfreeze: 'アンフリーズ'
  },
  attendanceRecord: {
    exportRecord: 'ダウンロード',
    device: 'デバイス',
    employee: '従業員',
    pin: '従業員番号',
    sn: 'SN',
    deviceName: '名前',
    to: 'へ',
    checktime: 'パンチタイム',
    workcode: '勤怠コード',
    dataRange: '日付範囲',
    commitTime: '時刻',
    punchTime: 'パンチタイム',
    lastweek: '先週',
    lastmonth: '先月',
    lastThreeMonths: '過去3ヶ月間',
    exportResult: '検索結果のエクスポートする  ',
    exportAll: ' すべてエクスポートする',
    verifyPhoto: '写真を確認する',
    view: '表示'
  },
  witnessRecord: {
    checkRecord: '記録確認する  ',
    personRecord: '立会記録',
    checkFail: '  失敗を確認する ',
    checkSuccess: '  チェックを成功した',
    bornPerson: '「禁止された人員」',
    checkTime: ' 時間を確認する',
    checkResult: ' 結果を チェックする',
    employeeNo: '人数',
    normalTemperature: '正常温度',
    abnormalTemperature: '異常温度',
    deviceSn: 'Sn',
    temperature: '温度',
    hasMask: 'マスク着用',
    yes: '確認',
    no: 'キャンセル',
    checkMode: '検証方法',
    name: 'の名前をあげる',
    beginEndTime: '開始時間',
    accEvent: 'アクセスイベント',
    operatorPerson: 'オペレーター',
    normalEvent: '通常イベント',
    warnEvent: '警告イベント',
    abnormalEvent: '異常イベント',
    doorNum: 'ドア番号',
    time: '時間',
    outInStatus: 'インまたはアウト',
    doorEvent: 'アクセスイベント'
  },
  verifyintModel: {
    '0': '指静脈/顔/指紋/カード/パスワード（自動認識）',
    '1': '指紋のみ',
    '2': 'ユーザーID認証 ',
    '3': 'パスワードのみ ',
    '4': 'カードのみ ',
    '5': '指紋またはパスワード ',
    '6': '指紋またはカード ',
    '7': 'カードまたはパスワード ',
    '8': 'ユーザーID + 指紋 ',
    '9': '指紋＋パスワード ',
    '10': ' カード＋指紋 ',
    '11': ' カード＋パスワード ',
    '12': ' 指紋＋パスワード＋カード ',
    '13': ' ユーザーID＋指紋＋パスワード ',
    '14': ' ユーザーID＋指紋またはカード＋指紋 ',
    '15': ' 顔認証 ',
    '16': ' 顔認証＋指紋認証 ',
    '17': ' 顔認証＋パスワード ',
    '18': ' 顔＋カード ',
    '19': ' 顔＋指紋＋カード ',
    '20': ' 顔＋指紋＋パスワード ',
    '21': ' 指静脈',
    '22': ' 指静脈＋パスワード',
    '23': ' 指静脈＋カード ',
    '24': ' 指静脈＋パスワード＋カード ',
    '25': ' 手のひらプリント ',
    '26': ' 手のひらプリント＋カード',
    '27': ' 手のひらプリント＋顔',
    '28': ' 手のひらプリント＋指紋 ',
    '29': ' 掌紋＋指紋＋顔 ',
    '30': 'IDカードのみ',
    '31': 'IDカード＋顔',
    '32': '身分証明書＋顔＋信頼できる',
    '33': '身分証明書＋指紋＋顔',
    '34': ' 認証のみ信頼する',
    '200': ' その他',
    BioDataCount: '顔テンプレート（可視光）',
    FingerCount: '指紋 ',
    FaceCount: '顔テンプレート（近赤外光）'
  },
  company: {
    apiUserTips:
      'インターフェイスを呼び出しには、 APIをユニークIDとして渡される必要があります。',
    loginUserTips:
      'APIを使用する場合は、パラメータが必要になり、企業のアカウントの正当性を確認する',
    entryCompany: '会社を入力します。',
    selectCountry: '最初に国を選択してください',
    updateInfo: '会社情報を更新する',
    devList: '端末一覧',
    cmpInfo: '会社情報',
    logo: 'ロゴ',
    dataFormat: '日付形式',
    timeFormate: '時刻表示',
    language: '言語',
    state: '都道府県',
    country: '国名',
    zipCode: '郵便番号',
    city: '都市名',
    email: 'メールアドレス',
    phone: '電話番号',
    address: '住所',
    active: '活動状況',
    agentCode: '代理店コード',
    integrator: 'インテグレーター',
    enable: '利用可能可否',
    webSite: 'ウェブサイト',
    name: '企業名',
    code: '企業コード',
    type: '種類',
    accountInfo: '基本情報',
    companyContactInfo: '連絡先',
    Contact: '連絡先',
    preference: 'プリセッティング',
    address1: 'ストリート1',
    address2: 'ストリート2',
    address3: 'ストリート3',
    status: 'ステータス',
    Integrator: 'インテグレーター',
    industry: '業種',
    createdDate: '作成時間',
    modifiedDate: '変更した時間',
    employeeList: '従業員名簿',
    assEquipment: '関連機器',
    accAuthority: '入退室管理権限',
    companySetting: 'エンタープライズ構成',
    userCount: '登録人数',
    expirationDate: 'アカウント有効期間',
    confirmedAccount: 'アカウントを確認する',
    confirmedAccountTip: '現在のアカウントを有効にしますか?'
  },
  tenant: {
    companyList: '会社リスト',
    companyDetail: '会社概要',
    settings: '基本情報',
    accountUser: 'アカウント管理',
    configurations: 'パラメータ',
    owner: '会社名',
    parameterName: '名称',
    parameterValue: '値',
    dataConstraint: '説明',
    confirmRestoreTip: '本当にデフォルトに戻しますか？',
    confirmRestore: 'リストア確認',
    cancelRestore: 'リストアのキャンセル',
    adminAccount: '管理者名',
    integrationAccount: '統合アカウント',
    device: 'デバイス'
  },
  sysOption: {
    not: 'キャンセル',
    uploadFail:
      'アップロードに失敗しました。html形式とutf-8のエンコード形式でファイルをアップロードしてください。',
    selectLang: '言語を選択してください',
    download: 'ダウンロード',
    inputFile: 'ファイルを選択してください',
    selectFile: 'ファイルを選択',
    verLang: '言語を選択する',
    inputVer: 'バージョンの番号情報を入力してください',
    version: 'バージョン番号',
    uploadFile: 'ファイルをアップロード',
    createTime: '作成時間',
    fileName: 'ファイル名',
    agreeManager: 'プライバシーポリシーの管理',
    deleteParams: 'このイベントタイプは削除される？',
    updateDeviceParams: 'デバイスのパラメータを更新する',
    addDeviceParams: 'デバイスのパラメータを追加する',
    dictionaryType: '辞書タイプ',
    paramsValueType: 'パラメータ値の種類',
    isAllowModify: '編集を許可する？',
    onlyRead: '読み取り専用',
    readAndWrite: '読取り/書込み',
    protocol: '通信プロトコル',
    inputDictionary: 'データ辞書の種類を入力してください。',
    dictionary: '辞書タイプ',
    paramsValue: 'パラメータ値の種類',
    inputConnection: '関連するパラメータを入力してください。',
    connect: '関連するパラメータ',
    selectWay: '方法を選択してください',
    isAllow: '編集を許可する？',
    inputReadWay: '読み出し/書き込み方式を選択してください',
    readWay: '読み出しと書き込みの状態',
    inputSaveParam: 'ストレージ名を入力してください',
    saveParam: 'ストレージ名',
    inputOriginalParams:
      'オリジナルのパラメータを入力してください',
    originalParam: 'オリジナルパラメータ',
    searchProtocol: '通信プロトコルを選択してください',
    deleteEvent: 'このイベントタイプは削除する？',
    updateAccEventType: 'アクセス制御イベントタイプの更新',
    addAccEventType: 'アクセス制御のためのイベントタイプの追加',
    desc: '商品説明',
    inputDescValue: '説明を入力してください',
    inputDescName: '説明の名称を入力してください',
    eventDesc: 'イベント内容',
    inputStandardType:
      '標準的なイベントの種類を入力してください',
    standardType: '標準イベントタイプ',
    inputOriginalType:
      'オリジナルのイベントの種類を入力してください',
    originalType: 'オリジナルイベントの種類',
    eventType: 'イベントの種類を選択してください。',
    accEventType: 'アクセス制御イベントタイプ',
    deviceParamsType: '機器パラメータ管理',
    desPla: '説明を入力してください。',
    plainPla: '値を入力してください',
    namePla: '名前を入力してください',
    yes: 'はい',
    no: 'いいえ',
    readonly: '読み取り専用',
    enable: '有効化',
    code: ' パラメータ名',
    plainVal: '価値',
    tocompany: '同期',
    des: '説明',
    add: 'システムパラメーターの追加',
    update: 'システムパラメーターの更新',
    requireCode: 'パラメータ名を入力してください',
    requirePlainVal: 'パラメータ値を入力してください'
  },
  pushlog: {
    dataType: 'データ型',
    pushResult: 'プッシュ結果',
    success: '成功',
    fail: '失敗',
    pushTime: 'プッシュ時刻',
    pushDetails: 'プッシュのログ詳細'
  },
  cancelAccount: {
    cancelAccount: 'アカウントの破棄',
    agreements: '契約書・規約',
    view: '表示',
    developer: '開発者サービス規',
    privacyPolicy: 'プライバシーポリシー',
    dataProcess: 'データ処理に関する同意書',
    withdrawal: '同意の撤回',
    cancelTip:
      'この操作によりアカウントがログアウトされる。ログアウトすると、再度ログインすることはできない。 スマート DBS は、アカウントに関連するすべてのデータも消去する。慎重に操作してください。',
    exportTip:
      'このアカウントからログアウトしようとしている。ログアウトすると、プラットフォームは保存されたデータを破棄し保存データがなくなる。',
    clickHere: 'ここをクリック',
    verificationType: '検証方法',
    changeType: '変更',
    code: 'コード',
    inputCode: '検証コードを入力してください',
    withdraw: '引き出す',
    click: 'ゲット',
    protocol: 'プロトコル'
  },
  exportData: {
    recordData: '記録データ',
    tip: '最近1ヶ月間のみ利用可能',
    infoData: '情報データ',
    export: 'エクスポート',
    exportTip:
      'チェックしたデータは、指定したメールボックスに送信されます。以下にメールを正常に受信できるメールボックスを入力してください。',
    inputEmail: 'メールアドレスを入力してください',
    emainValidate: '正しいメールアドレスを入力してください',
    sendEmailTip:
      'バックエンドで非同期でデータを処理しています。後ほどメールをご確認ください。',
    attendanceRecord: '出席記録',
    verificationRecord: '検証記録',
    witnessRecord: '立会者記録',
    companyInformation: '会社情報',
    organizationalStructure: '組織構成'
  },
  el: {
    colorpicker: { confirm: 'OK', clear: 'クリア' },
    datepicker: {
      now: '現在',
      today: '今日',
      cancel: 'キャンセル',
      clear: 'クリア',
      confirm: 'OK',
      selectDate: '日付を選択',
      selectTime: '時間を選択',
      startDate: '開始日',
      startTime: '開始時間',
      endDate: '終了日',
      endTime: '終了時間',
      prevYear: '前年',
      nextYear: '翌年',
      prevMonth: '前月',
      nextMonth: '翌月',
      year: '年',
      month1: '1月',
      month2: '2月',
      month3: '3月',
      month4: '4月',
      month5: '5月',
      month6: '6月',
      month7: '7月',
      month8: '8月',
      month9: '9月',
      month10: '10月',
      month11: '11月',
      month12: '12月',
      week: '週次',
      weeks: {
        sun: '日',
        mon: '月',
        tue: '火',
        wed: '水',
        thu: '木',
        fri: '金',
        sat: '土'
      },
      months: {
        jan: '1月',
        feb: '2月',
        mar: '3月',
        apr: '4月',
        may: '5月',
        jun: '6月',
        jul: '7月',
        aug: '8月',
        sep: '9月',
        oct: '10月',
        nov: '11月',
        dec: '12月'
      }
    },
    select: {
      loading: 'ロード中',
      noMatch: 'データなし',
      noData: 'データなし',
      placeholder: '選択してください'
    },
    cascader: {
      noMatch: 'データなし',
      loading: 'ロード中',
      placeholder: '選択してください',
      noData: 'データなし'
    },
    pagination: {
      goto: '',
      pagesize: '件/ページ',
      total: '総計 {total} 件',
      pageClassifier: 'ページ目へ'
    },
    messagebox: {
      title: 'メッセージ',
      confirm: 'OK',
      cancel: 'キャンセル',
      error: '正しくない入力'
    },
    upload: {
      deleteTip: 'Delキーを押して削除する',
      delete: '削除する',
      preview: 'プレビュー',
      continue: '続行する'
    },
    table: {
      emptyText: 'データなし',
      confirmFilter: '確認',
      resetFilter: '初期化',
      clearFilter: 'すべて',
      sumText: '合計'
    },
    tree: { emptyText: 'データなし' },
    transfer: {
      noMatch: 'データなし',
      noData: 'データなし',
      titles: ['リスト 1', 'リスト 2'],
      filterPlaceholder: 'キーワードを入力',
      noCheckedFormat: '総計 {total} 件',
      hasCheckedFormat: '{checked}/{total} を選択した'
    },
    image: { error: 'FAILED' },
    pageHeader: { title: 'Back' },
    popconfirm: { confirmButtonText: 'Yes', cancelButtonText: 'No' },
    empty: { description: 'データなし' }
  },
  email: {
    details: 'メールの詳細',
    server: 'メールボックス サーバー',
    port: 'ポート',
    account: '電子メールアドレス',
    password: 'パスワード',
    sendername: '送信者名',
    sender: '差出人',
    recipient: '受取人',
    subject: 'テーマ',
    sendTime: '送信時間',
    status: '状態',
    emailsExpiryTip: 'アカウントの有効期限を通知',
    cronVal: 'メール送信頻度（日）',
    testConnection: 'テスト接続',
    save: '保存',
    threshold: 'アカウントの有効期限満了までの通知日',
    failReason: '失敗の理由',
    content: 'メールの内容'
  },
  inspection: {
    sn: 'スン',
    exceptionType: '状態',
    timesTip: 'アルコール度数検査器の使用回数（残量・上限）',
    daysTip: 'ワインテスターの使用日数（残り・上限）',
    memory: 'メモリ (使用可能/合計) M',
    normal: '正常',
    exception: '異常な',
    warning: '暖かい',
    storage: 'ストレージ (利用可能/合計) M',
    inspectionTime: '検査時間',
    warningContent: '警報内容',
    warningTime: 'アラーム時間',
    companyCode: '企業番号',
    name: '会社名',
    expiryData: '有効期限',
    status: '状態',
    onLine: 'オンライン',
    expired: '期限切れ',
    expiringSoon: 'もうすぐ期限切れ',
    offLine: 'オフライン',
    companyNumber: '会社数',
    inspectionTableTitle: '設備巡検警報報告',
    companyExpiryTableTitle: 'エンタープライズ有効期限レポート',
    daysRemaining: '残りの日数'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/languages/ja/ja.js